export default {
    blacklist: {
        prodTitle1: "Daftar Hitam",
        prodContent1: "Melalui nomor ID pelanggan, nomor ponsel, nomor perangkat, IP, wajah, dapat dirumuskan dan menentukan apakah pelanggan ada dalam daftar hitam, lebih lanjut melengkapi informasi profil pelanggan,bertujuan kurangi risiko bisnis, kurangi risiko penipuan, kegiatan penipuan jahat, dan perilaku lainnya.",

        prodTwoTitle1: "Pengenalan",
        prodContentSon1: "Berdasarkan data pelangan pada historis pinjaman, konsumsi, dan perilaku, maka menghasilkan laporan khusus untuk mencegah penipuan berisiko tinggi dan menyediakan layanan daftar hitam bagi perusahaan.",

        prodThreeTitle1: "Keunggulan",
        prodThreeContentTitleSon1: "Tingkat Pengenalan Tinggi",
        prodThreeContentSon1: "Jutaan Data Pengendalian Resiko.",

        prodThreeContentTitleSon2: "Respon cepat",
        prodThreeContentSon2: "Respons Layanan Dalam Milidetik.",

        prodThreeContentTitleSon3: "Sumber Data Resmi",
        prodThreeContentSon3: "Terhubung dengan sumber data kontrol risiko dari pihak ketiga, memperbarui informasi terkini tepat waktu, merespons secara akurat dan efisien, dan menyediakan sistem perlindungan keamanan data untuk memastikan stabilitas dan keamanan interaksi data.",

        prodThreeContentTitleSon4: "Segmentasi Grup Pengguna",
        prodThreeContentSon4: "potret pelanggan dengan data multiparameter dan multidimensi.",
    },
    face:{
        prodTitle1:"产品优势",
        
        prodContentTitleSon1:"高精度模型",
        prodContentSon1:"百万级人脸训练模型",
        
        prodContentTitleSon2:"响应快",
        prodContentSon2:"服务毫秒级响应",

        prodContentTitleSon3:"鲁棒性强",
        prodContentSon3:"支持不同表情、不同年龄、复杂背景及光线下的精准识别",

        prodTwoTitle1:"产品应用场景",

        prodTwoContentTitleSon1:"金融业务",
        prodTwoContentSon1:"人脸识别技术在金融行业有着广阔的应用前景,主要可分为身份验证,智能识别与分析,业务创新支撑等应用方向。",
    
        prodTwoContentTitleSon2:"在线考试",
        prodTwoContentSon2:"为了进一步促进考试公平,越来越多的高校将人脸识别应用到课程考试当中。",
    
        prodTwoContentTitleSon3:"智慧社区",
        prodTwoContentSon3:"人脸识别进入社区,为打造现代化智慧社区助力,让民众的城市生活更加智能化。",
    
        prodTwoContentTitleSon4:"交通出行",
        prodTwoContentSon4:"交通二维码、电子标签、视频监控、交通仿真等服务的应用，推动交通行业向智能化、信息化方向发展。",
    
        prodTwoContentTitleSon5:"政务服务",
        prodTwoContentSon5:"'互联网+政务服务',人脸识别、语音搜索等人工智能技术已在政务领域全方位应用。",
    
        prodTwoContentTitleSon6:"酒店住宿",
        prodTwoContentSon6:"人脸识别是构建智慧酒店智能生态的基础，基于人脸识别技术,可打造从入住前到离店后的整体刷脸生态系统。",
    
        prodThreeTitle1:"产品演示",
    },
    ocr:{
        prodTitle1:"产品优势",
        
        prodContentTitleSon1:"高精确度",
        prodContentSon1:"精确识别复印件与照片信息并支持判断是否为原件",
        
        prodContentTitleSon2:"高并发",
        prodContentSon2:"支持秒内万级并发量",

        prodContentTitleSon3:"鲁棒性强",
        prodContentSon3:"支持多角度、复杂背景及光线的精准识别",

        prodTwoTitle1:"产品应用场景",

        prodTwoContentTitleSon1:"金融业务",
        prodTwoContentSon1:"快捷、准确、高效地实现金融业务的信息化、缩短每笔业务的操作时间、保存客户原始信息并对其进行电子认证,所有这一切都可以通过日益完善的OCR技术加以解决。",
    
        prodTwoContentTitleSon2:"政务服务",
        prodTwoContentSon2:"社会信息化不断加快，人们对信息快捷、有序的要求有着更高的渴望，OCR技术在办公自动化的深入应用，为国家机关、企事业单位实现无纸化办公提供了坚实的基础。",
    
        prodTwoContentTitleSon3:"出版印刷",
        prodTwoContentSon3:"OCR 识别技术已经比较成熟, OCR 产品被广泛地应用在新闻、印刷、出版、图书馆、办公自动化等各个行业。",
    
        prodThreeTitle1:"产品演示",
    },
    risk:{
        prodTitle1:"产品优势",
        
        prodContentTitleSon1:"识别率高",
        prodContentSon1:"百万级风控数据",
        
        prodContentTitleSon2:"响应快",
        prodContentSon2:"服务毫秒级响应",

        prodContentTitleSon3:"用户群细分",
        prodContentSon3:"多参数多维度输出客户画像",

        prodContentTitleSon4:"鲁棒性强",
        prodContentSon4:"支持不同表情、不同年龄、复杂背景及光线下的精准识别",

        prodTwoTitle1:"产品应用场景",

        prodTwoContentTitleSon1:"金融业务",
        prodTwoContentSon1:"智能风控强大的技术优势,给金融机构识别项目带来巨大便利,有利于银行等机构识别项目风险,优选投资,最终将发挥金融的作用,推动经济结构发展升级。",
    
        prodTwoContentTitleSon2:"智慧社区",
        prodTwoContentSon2:"门禁与访客系统、公共便民服务的身份验证系统、社区治安的视频监控。",
    
        prodTwoContentTitleSon3:"交通出行",
        prodTwoContentSon3:"在智能风控的新理念下，市区交通安全风险预警更及时，事故防降效果更明显，风险人脸及危险路段治理更有效，事故责任单位或个人追责更有力，尽可能将风险控制在事故之前。",
    
        prodThreeTitle1:"产品演示",
    },
    intelligent:{
        prodTitle1:"产品优势",
        
        prodContentTitleSon1:"闪电决策",
        prodContentSon1:"以业务为导向，研发集策略、规则、模型的一体化方案，闪电级部署，实现业务的迅捷式响应、低成本运营、轻量级运营。",
        
        prodContentTitleSon2:"海量高品质客源",
        prodContentSon2:"基于自有、三方的线上APP和线下经营实体，构建了多源头、立体化的获客渠道，每日可有效获取数百万客户相关资讯。为此，通过Seeder的大数据深度挖掘系统，可为金融机构平台提供定式化、海量的高品质客源。",

        prodContentTitleSon3:"精准画像",
        prodContentSon3:"Seeder科技平台在海量高品质客源基础上，基于金融业务需求，进行产品优化，构建多维度、精准的用户画像，实现客源金融属性的定量化分析。",

        prodContentTitleSon4:"低险高效",
        prodContentSon4:"金融机构获取了高品质的客源及其画像基础上，构建对应的金融方案，提高从客源到客户的转化效率，可降低欺诈客户比例、减少资金风险，进一步实现低风险、高收益的目标。",

        prodTwoTitle1:"合作媒体平台",

        prodThreeTitle1:"服务案例",

        btn1:"Kwai",
        btn2:"Cheetah Mobile",
        btn3:"Bytedance",

        btn1Content:{
            tabTitle1:"Kwai",
            tabText1:"合作产品",
            
            tabTitle2:"10 months",
            tabText2:"合作时间",

            tabTitle3:"Facebook, Google",
            tabText3:"合作媒体",

            tabTitle4:"$20,000 - $50,000",
            tabText4:"每日预算",

            tabTitle5:"IN, BR",
            tabText5:"投放区域",

            tabTitle6:"IN CPI  $0.30 - $0.39 IN RR 39%",
            tabText6:"关键数据",
        },
        btn2Content:{
            tabTitle1:"Live.me",
            tabText1:"合作产品",
            
            tabTitle2:"10 months",
            tabText2:"合作时间",

            tabTitle3:"Facebook, Google",
            tabText3:"合作媒体",

            tabTitle4:"$10,000 - $20,000",
            tabText4:"每日预算",

            tabTitle5:"IN  US  SA  etc",
            tabText5:"投放区域",

            tabTitle6:"IN CPI $0.35 - $0.40 IN RR 35%",
            tabText6:"关键数据",
        },
        btn3Content:{
            tabTitle1:"Tik Tok",
            tabText1:"合作产品",
            
            tabTitle2:"8 months",
            tabText2:"合作时间",

            tabTitle3:"Facebook",
            tabText3:"合作媒体",

            tabTitle4:"$20,000 - $50,000",
            tabText4:"每日预算",

            tabTitle5:"IN",
            tabText5:"投放区域",

            tabTitle6:"IN CPI $0.38 - $0.45 IN RR 42%",
            tabText6:"关键数据",
        }
    }
};
